"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideLeft = exports.SlideUp = exports.SlideDown = void 0;
const styled_components_1 = require("styled-components");
const SlideDown = (translation, duration = 300) => (0, styled_components_1.css) `
  transition: transform ${duration}ms;

  &.enter {
    transform: translateY(${translation});
  }

  &.enter-active {
    transform: translateY(0);
  }

  &.enter-done {
    transform: translateY(0);
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(${translation});
  }

  &.exit-done {
    transform: translateY(${translation});
  }
`;
exports.SlideDown = SlideDown;
const SlideUp = (translation, duration = 300) => (0, styled_components_1.css) `
  transition: transform ${duration}ms;

  &.enter {
    transform: translateY(-${translation});
  }

  &.enter-active {
    transform: translateY(0);
  }

  &.enter-done {
    transform: translateY(0);
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(-${translation});
  }

  &.exit-done {
    transform: translateY(-${translation});
  }
`;
exports.SlideUp = SlideUp;
const SlideLeft = (translation, duration = 300) => (0, styled_components_1.css) `
  transition: transform ${duration}ms;

  &.enter {
    transform: translateX(-${translation});
  }

  &.enter-active {
    transform: translateX(0);
  }

  &.enter-done {
    transform: translateX(0);
  }

  &.exit {
    transform: translateX(0);
  }

  &.exit-active {
    transform: translateX(-${translation});
  }

  &.exit-done {
    transform: translateX(-${translation});
  }
`;
exports.SlideLeft = SlideLeft;
